/* eslint-disable */
import React from "react";

const PaperPlaneIcon = () => (
  <svg width="38px" height="22px" viewBox="0 0 38 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <title>5657A516-795D-4621-BAF4-49E2F3FDD8B0</title>
    <g id="Checkout-Flow---Desktop" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeDasharray="0,0">
        <g id="PDP---Checkout---Shipping" transform="translate(-412.000000, -295.000000)" stroke="#242636">
            <g id="Group-7" transform="translate(413.000000, 296.000000)">
                <g id="Group-6" transform="translate(0.000000, 0.337646)">
                    <path d="M34.9687328,0 L23.2297346,13.2880621 L19.8277348,8.67629593 L16.5949707,11.0155325 L18.5010293,5.15076592 L16.5949707,0 L34.9687328,0 Z" id="Stroke-1"></path>
                    <path d="M18.5009766,5.15094666 L29.1842136,2.67871094 L19.8276826,8.67647648" id="Stroke-3"></path>
                    <path d="M17.7027836,13.833252 C17.6994895,15.6231934 15.1346061,20.7583117 9.23731204,16.402664 C2.46789993,11.4021927 -0.672217391,18.7089584 0.120017929,19.9561939" id="Stroke-4"></path>
                </g>
            </g>
        </g>
    </g>
  </svg>
);

export default PaperPlaneIcon;
